export default {"src":"https://fishbrain.com/_next/static/media/michigan.1a25a49c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};